var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6zo0ts0hna)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 11v16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V11a3 3 0 0 1 3-3h2.307C8.934 8 10.396 7.01 11 5.5A3.977 3.977 0 0 1 14.693 3h6.335a4 4 0 0 1 3.578 2.211l.288.578A4 4 0 0 0 28.472 8H31a3 3 0 0 1 3 3zm-20.993 7.3c0-2.792 2.236-5.055 4.993-5.055 2.758 0 4.993 2.263 4.993 5.055S20.758 23.355 18 23.355c-2.758 0-4.993-2.263-4.993-5.055zM18 11.1c-3.927 0-7.111 3.223-7.111 7.2 0 3.976 3.184 7.2 7.111 7.2 3.927 0 7.111-3.224 7.111-7.2 0-3.977-3.184-7.2-7.111-7.2z",
    fill: "#222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6zo0ts0hna"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v33H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlack);
export default __webpack_public_path__ + "static/media/camera_black.6098e1d9fa79221f4b24e3c65dd63543.svg";
export { ForwardRef as ReactComponent };